import React, { useContext, useEffect, useState } from "react";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import Image from "../../Components/Reusable/Image";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import { handleApiErrors, InputType } from "../../Utils/Utils";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import DynamicService from "../../Services/DynamicService";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import Calanderimg from '../../assets/images/png/fi_12671954.png'
import * as XLSX from 'xlsx';
import DataProvider from "../../Utils/DataProvider";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import PackagesService from "../../Services/PackagesService";
import { AuthContext } from "../../Context/authContext";



const CoordinatorListing = () => {
  const [data, setData] = useState([]);
  const [dataExport, setDataExport] = useState([]);
  const [searchQuery, setSearchQuery] = useState(null);
  const [searchDistrict, setSearchDistrict] = useState(null);
  const [searchTaluka, setSearchTaluka] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [coordinators, setCoordinators] = useState({});
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const {user} = useContext(AuthContext)
 
  const handleStartDateChange = (date) => setStartDate(date);
  const handleEndDateChange = (date) => setEndDate(date);

  const CustomDateInput = ({ value, onClick }) => (
    <div className="custom-date-input" onClick={onClick}>
      <input
        type="text"
        placeholder="From"
        value={value}
        readOnly
        className="form-control"
      />
      <img src={Calanderimg} alt="" className="calendar-icon" />
    </div>
  );
  const CustomDateInputTo = ({ value, onClick }) => (
    <div className="custom-date-input" onClick={onClick}>
      <input
        type="text"
        placeholder="To"
        value={value}
        readOnly
        className="form-control"
      />
      <img src={Calanderimg} alt="" className="calendar-icon" />
    </div>
  );

  const fetchData = async () => {
    try {
      const response = await DynamicService.getAllCoordinator(
        offset,
        limit,
        searchQuery || "",
        searchDistrict || "",
        searchTaluka || "",
        startDate,
        endDate,
      );
      
      setData(response.UserData);
      setAvailableDataCount(response.availableDataCount);

      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const getAllCoordinatorWithoutPagination = async () => {
    try {
      const response = await DynamicService.getAllCoordinatorWithoutPagination();
      setDataExport(response.data);
      // setAvailableDataCount(response.availableDataCount);
      
    } catch (error) {
      handleApiErrors(error);
    }
  };

  // const getAllPackages = async () => {
  //   try {
  //     const response = await PackagesService.getAllPackages(
  //       offset,
  //       limit,
  //       searchQuery || ""
  //     );
  //     console.log("API response:", response.data);
  //     setPackageData(response.data); 
  //   } catch (error) {
  //     handleApiErrors(error);
  //   }
  // };
  

  const deleteSingleCoordinator = async (id) => {
    try {
      await DynamicService.deleteCoordinator([id]);
      toast.success("Coordinator Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteMultipleCoordinators = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item.coordinator_id);
          }
        });
      }
      await DynamicService.deleteCoordinator(itemsToDelete);
      toast.success("Coordinators Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  useEffect(() => {
    fetchData();
    getAllCoordinatorWithoutPagination()
  }, [offset]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (searchQuery != null ||searchDistrict != null || searchTaluka != null) {
        fetchData();
      }
    }, 100);
    return () => clearTimeout(timeOutId);
  }, [searchQuery,searchDistrict,searchTaluka]);


  useEffect(() => {
    const fetchCoordinatorDataByDate = () => {
      if (startDate || endDate) {
        fetchData(startDate, endDate);
      }
    };

    const timeoutId = setTimeout(fetchCoordinatorDataByDate, 500); // Debounce the request

    return () => clearTimeout(timeoutId); // Clear timeout if date changes again quickly
  }, [startDate, endDate]);

  const exportToExcel = (data, fileName) => {
    if (!data || data.length === 0) {
      toast.info("No data to export");
      return;
    }

    // Create a worksheet from data
    const ws = XLSX.utils.json_to_sheet(data);

    // Define the grand total row
    // const grandTotalRow = [
    //   '', '', '', '', '', '', '', '', '', '', '', '', 'Grand Total', 
    // ];

    // Add grand total row to the end of the sheet
    // XLSX.utils.sheet_add_aoa(ws, [grandTotalRow], { origin: -1 });

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Write the workbook to file
    XLSX.writeFile(wb, fileName);
  };

  const handleExportClick = () => {
    const name = coordinators.coordinatorName || "Coordinator";
    const fileName = `${name} Coordinator Data Report.xlsx`;
    exportToExcel(dataExport, fileName);
  };
  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0 text-uppercase">Coordinator Data Reports</h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">
            Coordinator Page Listing
          </h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        {/* <h1 className="black fs-18 fw-600 mb-0"> Coordinator Page Listing</h1>
       */}
        <div className="table_title">
          <div className="table_headings ">
            <h1 className="black fs-18 fw-600 mb-0">
              <div
                className="table_delete_icon"
                style={{
                  opacity:
                    data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                    pointerEvents: data?.findIndex((item) => item.isChecked) === -1 ? 'none' : 'auto',
                }}
                onClick={() => {


                  const reportsPrivilege = user?.setPrivileges?.find(
                    (priv) => priv.parameter === "Reports"
                  );
                  if (!reportsPrivilege?.delete) {
                    // If the user does not have delete permission, show a toast warning
                    toast.warning("You don't have permission to delete coordinators.");
                    return;
                  }

                  if (!(data.findIndex((item) => item.isChecked) == -1)) {
                    setIsMultipleDelete(true);
                    setShowDeleteModal(true);
                  }
                }}
              >
                <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
              </div>
            </h1>
            <div className="d-flex gap-4 align-items-center ">
              <div className="position-relative ">
                <input
                  type="search"
                  className="search_box search_bar"
                  placeholder="Search "
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                />
                <Image
                  src={SvgImages.search}
                  style={ImageFilters.gray}
                  className="search_icon"
                  alt="Search Icon"
                  height="20px"
                />
              </div>
            </div>
          </div>
        </div>



        <div className=" row table_title align-items-center responsivetablepackagetwo">
          <div className="col-lg-6 col-md-12 col-xl-3 gap-2 col-12 pe-0 d-flex  align-items-center sectionPayouts  datepickerstyle">
            <div className="">Date:</div>
            <div  >
              <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                dateFormat="yyyy-MM-dd"
                isClearable
                placeholderText="From"
                maxDate={new Date()}
                customInput={<CustomDateInput />}
              />
            </div>
            <div >
              <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                dateFormat="yyyy-MM-dd"
                isClearable
                placeholderText="To"
                minDate={startDate}
                maxDate={new Date()}
                customInput={<CustomDateInputTo />}
              />
            </div>

          </div>
          <div className="col-xl-7 my-2 col-lg-12 col-md-12 gap-2 Responsivesearchbars  align-items-center d-flex">
            
            <div className="col-md-8 col-lg-6  col-sm-12" >
              <CustomTextField
                placeholder="Search District"
                inputType={InputType.text}
                // resetValue={resetFilterDistrict}
                 additionalClasses="profile_edit"
                optionalclass='marginbtm'
                // setResetValue={setResetFilterDistrict}
                onChange={(e) => {
                  setSearchDistrict(e.target.value);
                }}
                // options={
                //   [{ value: "", label: "All" }, ...filterDistricts?.map((e) => { return { value: e._id, label: e.name } }) ?? []]
                // }

              />
            </div>
            <div className="col-md-8 col-lg-6 col-sm-12" >
              <CustomTextField
                placeholder="Search Taluka"
                inputType={InputType.text}
                // resetValue={resetFilterDistrict}
                // setResetValue={setResetFilterDistrict}
                additionalClasses="profile_edit"
                optionalclass='marginbtm'
                onChange={(e) => {
                  setSearchTaluka(e.target.value);
                }}
                // options={
                //   [{ value: "", label: "All" }, ...filterDistricts?.map((e) => { return { value: e._id, label: e.name } }) ?? []]
                // }

              /></div>
          </div>
          <div className="col-md-12  col-lg-12 col-xl-2  col-12 d-flex align-items-center justify-content-end respoexportbtn ">
            <ButtonWithIcon
              text={"Export"}
              icon={PngImages.xlspic}
              onClick={handleExportClick}
            />
          </div>


        </div>







        <div style={{ overflowX: "auto" }}>
          <table
            className="table mb-0 "
            id="dtHorizontalExample"
            cellSpacing="0"
            width="100%"
          >
            <thead>
              <tr className="table_heading">
                <th scope="col" style={{ width: "5%" }}>
                  <label className="d-flex align-items-center justify-content-center">
                    <input
                      className="cursor-pointer"
                      type="checkbox"
                      style={{ height: "16px", aspectRatio: 1 }}
                      checked={
                        data?.length > 0 &&
                        data?.findIndex((item) => !item.isChecked) == -1
                      }
                      onChange={(value) => {
                        var updatedData = data;
                        updatedData.map((element) => {
                          element.isChecked = value.target.checked;
                        });
                        setData([...updatedData]);
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Sr No.
                </th>
                <th scope="col" style={{ width: "10%" }}>
                  Name
                </th>
                <th scope="col" style={{ width: "10%" }}>
                  Email
                </th>
                <th scope="col" style={{ width: "10%" }}>
                  Mobile No.
                </th>
                <th scope="col" style={{ width: "10%" }}>
                  Date of Birth
                </th>
                {/* <th scope="col" style={{ width: "15%" }}>
                      Unique Code
                    </th> */}

                <th scope="col" style={{ width: "10%" }}>
                  12th Pass
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg_light">
              {data?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <label className="d-flex align-items-center justify-content-center">
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        checked={item.isChecked || false}
                        style={{ height: "16px", aspectRatio: 1 }}
                        onChange={(value) => {
                          var updatedData = data;
                          updatedData[index].isChecked =
                            value.target.checked;
                          setData([...updatedData]);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </td>
                  <td>{limit * offset + (index + 1)}</td>
                  <td>{item.coordinatorName}</td>

                  <td>{item.email}</td>
                  <td>{item.mobile}</td>
                  <td>{dayjs(item.dateOfBirth).format("DD MMM YYYY")}</td>
                  {/* <td>{item.referralCode}</td> */}
                  <td>{item.qualification === '12th Standared' ? <span className="greenyes fs-14 text-capitalize fw-500 ">Yes</span> : <span className="redno text-capitalize fs-14 fw-500 ">No</span>}</td>
                  <td>
                    <div className="d-flex gap_8">
                      <a className="delete_icons cursor-pointer">
                        <Image
                          src={SvgImages.deleteIcon}
                          style={ImageFilters.red}
                          data-bs-target="#delete-modal"
                          data-bs-toggle="modal"
                          alt="Delete Icon"
                          onClick={() => {

                            const reportsPrivilege = user?.setPrivileges?.find(
                              (priv) => priv.parameter === "Reports"
                            );
                            if (!reportsPrivilege?.delete) {
                              // If the user does not have delete permission, show a toast warning
                              toast.warning("You don't have permission to delete coordinator.");
                              return;
                            }
  

                            setDeleteId(item.coordinator_id);
                            setIsMultipleDelete(false);
                            setShowDeleteModal(true);
                          }}
                        />
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>


        </div>
        {generatePaginationFooter(
          availableDataCount,
          limit,
          offset,
          setOffset
        )}

      </div>

      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete selected coordinators?"
            : "Are you sure want to delete coordinator?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete
            ? deleteMultipleCoordinators()
            : deleteSingleCoordinator(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />
    </div>
  );
};

export default CoordinatorListing;
